import { axiosInstance } from '../Config/axios';

const API_URL = `v1/assets/`;
const API_DELETED_URL = `v1/assets-deleted/`;

// Función para listar los activos (GET)
export const getAssets = async (params) => {
  try {
    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los activos:', error);
    throw error;
  }
};

export const getAssetCategories = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}config/categories/`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las categorías de activos:', error);
    throw error;
  }
};

// Obtener una activo por código
export const getAssetsByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el activo con código ${code}:`, error);
    throw error;
  }
};

// Función para crear un nuevo activo (POST)
export const createAsset = async (assetData) => {
  try {
    const response = await axiosInstance.post(API_URL, assetData);
    return response.data;
  } catch (error) {
    console.error('Error al crear el activo:', error);
    throw error;
  }
};

// Función para actualizar un activo (PUT)
export const updateAsset = async (id, assetData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${id}/`, assetData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el activo:', error);
    throw error;
  }
};

// Función para eliminar un activo (DELETE)
export const deleteAsset = async (id) => {
  try {
    await axiosInstance.delete(`${API_URL}${id}/`);
  } catch (error) {
    console.error('Error al eliminar el activo:', error);
    throw error;
  }
};

// Función para listar los activos eliminados (GET)
export const getAssetsDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los activos eliminados:', error);
    throw error;
  }
};

// Obtener una activo eliminado por código (GET)
export const getAssetsDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el activo eliminado con código ${code}:`, error);
    throw error;
  }
};
